/**
 * Where the Claude API key lives. Currently Drive's hidden appDataFolder, so
 * it follows the user between devices. Swapping to localStorage means
 * rewriting only this file.
 */
import { appDataDelete, appDataRead, appDataWrite } from './google/drive'

const FILE = 'settings.json'

interface Settings {
  anthropicKey?: string
}

async function read(): Promise<Settings> {
  const text = await appDataRead(FILE)
  if (!text) return {}
  try {
    return JSON.parse(text) as Settings
  } catch {
    return {}
  }
}

export const keyStore = {
  async get(): Promise<string | undefined> {
    return (await read()).anthropicKey || undefined
  },
  async set(key: string): Promise<void> {
    await appDataWrite(FILE, JSON.stringify({ ...(await read()), anthropicKey: key.trim() }))
  },
  async clear(): Promise<void> {
    await appDataDelete(FILE)
  },
}
